module.exports = __webpack_public_path__ + "static/media/stage2.edc5dbf6.svg";